export default __webpack_public_path__ + "static/media/gallery-profile.d7b6da7b.png";